/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { RfqHeadingListItemDto } from './rfq-structure.dto';
import { RfqHeadingListItemMapper } from './rfq-structure.mapper';

@Injectable()
export class RfqStructureRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAll(): Observable<RfqHeadingListItemDto[]> {
    return this.httpGet(`${this.bp}/rfq-structure`, arrayOf(RfqHeadingListItemMapper));
  }

  update(headingList: RfqHeadingListItemDto[]): Observable<RfqHeadingListItemDto[]> {
    return this.httpPut(`${this.bp}/rfq-structure`, headingList, arrayOf(RfqHeadingListItemMapper));
  }
}
